import { Option } from '../../../filters-toolbar/filters-toolbar.model';
import { ColorSchemeClass } from '../../../theme.const';

/** Option object that uses a color scheme class as key */
export type ThemeOption = Option<ColorSchemeClass, string>;
/** Option object that uses a view label as key */
export type ThemeSettingsSection = Option<SettingsFilterView, string>;

export type LeaseRateSelection = Option<SettingsLeaseType, string>;

/** Existing Filter View keys */
export enum SettingsFilterView {
  Expiry = 'expiry',
  Industry = 'industry',
  Agency = 'agency',
  Usage = 'usage',
  Occupiers = 'occupier',
  None = 'none',
}

/** Existing Rate Types kays */
export enum SettingsLeaseType {
  AskingRent = 'askingRent',
  BaseRent = 'baseRent',
  EffectiveRent = 'effectiveRent',
}

export const OptimzeScaleOption: number[] = [1, 5, 10];
export interface SpaceCardDetails {
  suiteNumber: boolean;
  leaseEndingDate: boolean;
  spaceSize: boolean;
  rentDate: boolean;
  showLeaseRate: boolean;
  tenantRepAgency: boolean;
  leaseRateOpts: string;
  includeEstimatedRates?: boolean;
  includeEstimatedRateIndicator?: boolean;
}

export interface OptimzeScaleItem {
  isOptimzeScale: boolean;
  minimunScale: number;
}
export interface Settings {
  displayOptions: {
    showElevators: boolean;
    showTotalFloorSize: boolean;
  };
  // TODO: define floorOptions: string; // regex numbers,hyphen and commas
  cardDetails: SpaceCardDetails;
  colorScheme: {
    expiry: ColorSchemeClass;
    leaseYear: ColorSchemeClass;
    industry: ColorSchemeClass;
    agency: ColorSchemeClass;
    usage: ColorSchemeClass;
    occupier: ColorSchemeClass;
    brand: ColorSchemeClass;
    none: ColorSchemeClass;
  };
  optimizeScale: OptimzeScaleItem;
}
